module.exports = __webpack_public_path__ + "img/1.b72b307d.png";